import { useFullUserProfileContext } from "Bands/contexts";
import { UserSeatPreference } from "Bands/types";
import { useUserPreferenceRenderLine } from "Bands/utils";
import { FC } from "react";
import { copy } from "shared/assets";
import { Plus } from "shared/assets/icons";
import { Button, List, MainTeaser, Message } from "shared/components";
import { Spacer } from "shared/layout";
import { Icon } from "shared/styles";
import { ITheme } from "shared/types";

const { userFlightPreferences: flightCopy } = copy;

interface Props {
  handleShowModal?: (v: boolean) => void;
}

export const UserFlightPreferences: FC<Props> = ({ handleShowModal }) => {
  const { hasFlightPreferences, flightPreferences } = useFullUserProfileContext();

  const { seatPreference } = flightPreferences || {};

  const { renderLine } = useUserPreferenceRenderLine();

  const renderTeaser = () => (
    <List>
      {renderLine(
        flightCopy.fields.seatPreference.title,
        (seatPreference ?? UserSeatPreference.none).replaceAll("_", " ")
      )}
    </List>
  );

  return (
    <>
      {hasFlightPreferences ? (
        <MainTeaser
          subTitleComponent={renderTeaser()}
          actions={
            handleShowModal && [
              {
                label: copy.actions.edit,
                handleClick: () => handleShowModal(true),
              },
            ]
          }
        />
      ) : (
        <Spacer size="s">
          <Message>No flight preferences added yet</Message>
          <Spacer size="s">
            <Button
              onClick={() => handleShowModal && handleShowModal(true)}
              data-testid="add_social_security_form_button"
              theme={ITheme.secondary}
            >
              <Icon as={Plus} />
              <span>Add flight preferences</span>
            </Button>
          </Spacer>
        </Spacer>
      )}
    </>
  );
};
